(() => {
  if (customElements.get('pdp-dose-line')) return;

  class PdpDoseLine extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
    }

    // global.js dispatches a bubbling change on the product form's input[name="id"] after a variant switch
    onVariantChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;

      const form = document.getElementById(this.dataset.formId);
      if (!form || !form.contains(input)) return;

      this.querySelectorAll('[data-variant-id]').forEach((item) => {
        item.hidden = item.dataset.variantId !== input.value;
      });
    }
  }

  customElements.define('pdp-dose-line', PdpDoseLine);
})();
